import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Utils from 'utils';
// 公共样式
import 'assets/css/common.less';
import Config from 'config/Config';

// 主页面
import Layout from 'widget/Layout/LayoutView';
import { silentLogin } from 'utils/decorator';
import ToWeapp from 'pages/Shop/Home/ShopHome/components/ToWeapp';
import 'biz-micro-services-ui/packages/yofoui/api/inject';
import { PreviewMediaHost } from 'yofoui/customized/preViewMedia';
import OverlayRoot from 'middlePlatform/components/core/overlayRoot';
import { ensureSentry } from 'utils/sentryLoader';
import { schedulePreloadMods } from 'utils/dynamicInject';

const APP_PRELOAD_MODS = [
  'LoginMod',
  'PersonalMod',
  'ShoppingCartMod',
  'CheckOrderMod',
  'RegisterMod'
];

@silentLogin
@inject('AppMod')
@inject('LoginMod')
@observer
class AppView extends Component {
  saStartTime = new Date();

  constructor(props, context) {
    super(props, context);
    this.appMod = this.props.AppMod;
    this.loginMod = this.props.LoginMod;
  }

  // React 错误边界 - 捕获组件树中的错误
  componentDidCatch(error, errorInfo) {
    console.error('[App] 捕获到错误:', error, errorInfo);
    ensureSentry();

    window.sentry &&
      window.sentry.trackReport({
        error,
        extra: {
          ...errorInfo,
          capturedAt: 'AppView-componentDidCatch'
        }
      });
  }

  componentWillMount() {
    this.appMod.getMajorEvents();
    // 完成：插入真实 DOM前
    // const isApp = window.location.href.includes('app=');
    // this.appMod.setApp(isApp);
    // if (isApp) {
    // const token = Utils.getQueryString('token');
    // const memberCardNum = Utils.getQueryString('memberCardNum');
    // const userId = Utils.getQueryString('userId');
    // // 设置token
    // token && Utils.setLocalCache(Config.authName, token);
    // // 设置会员卡号
    // memberCardNum && Utils.setLocalCache(Config.memberCardNum, memberCardNum);
    // // 设置用户id
    // userId && Utils.setLocalCache(Config.userId, userId);
    // // 重写这两个方法，以监控路由跳转次数
    // window.app.routerGoTo = path => {
    //   this.appMod.addHistory();
    //   window.app.routerGoTo(path);
    // };
    // window.app.router.goBack = () => {
    //   this.appMod.minusHistory();
    //   window.app.router.goBack();
    // };
    // }
    // if (`${this.props.location.pathname}` === '/') {
    //   window.app.routerRedirect('/shop/home');
    // }

    // 补全全局埋点信息
    const userInfo = Utils.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
    sensors.registerPage({
      $user_id: userInfo.id || '',
      cardCode: userInfo.cardCode || '',
      realName: userInfo.realName || '',
      userName: userInfo.userName || '',
      shopNo: userInfo.shopNo || '',
      userType: userInfo.userType || '',
      client: 'H5'
    });

    // 神策埋点 SPA应用切换 手动模式
    sensors.quick('autoTrackSinglePage', {
      view_dur: 0
    });
    window.addEventListener('hashchange', (e) => {
      history.replaceState(history.state, '', e.newURL);
      // 神策埋点 SPA应用切换 手动模式
      let view_dur = new Date().getTime() - this.saStartTime.getTime();
      this.saStartTime = new Date();
      sensors.quick('autoTrackSinglePage', { view_dur: view_dur || 0 });
    });

    // sentry - 设置用户信息
    const sentryUser = {
      user_id: userInfo.id || '',
      cardCode: userInfo.cardCode || '',
      realName: userInfo.realName || '',
      userName: userInfo.userName || '',
      shopNo: userInfo.shopNo || '',
      userType: userInfo.userType || '',
      client: 'H5',
      host: Config.HOST || ''
    };
    if (sentryUser.user_id || sentryUser.cardCode || sentryUser.userName) {
      window.sentry && window.sentry.setUser(sentryUser);
    }

    // 添加标签
    // Sentry.setTag("key", "value");
    // 添加额外信息
    // Sentry.setExtra("additionalData", { key: "value" });
  }

  componentDidMount() {
    // 检查是否已经绑定微信
    /* this.checkedBindInfo(); */
    // if (this.appMod.isApp) {
    //   document.addEventListener('message', msg => {
    //     const res = JSON.parse(msg.data);
    //     if (res.action === 'goBack') {
    //       if (this.appMod.historyCount) {
    //         window.app.router.goBack();
    //       } else {
    //         window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'goBack' }));
    //       }
    //     }
    //   });
    // }

    // 常用次级 Mod 在应用入口空闲期预加载，覆盖非首页直达场景。
    this.cancelPreloadMods = schedulePreloadMods(APP_PRELOAD_MODS, {
      idleTimeout: 3000,
      fallbackDelay: 3000
    });

    if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
      this.handleFontSize();
    } else {
      document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false);
    }
  }

  componentWillUnmount() {
    this.cancelPreloadMods && this.cancelPreloadMods();
  }

  handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    });
  }

  checkedBindInfo = () => {
    let { openId, unionId, accessToken } = this.appMod.wxInfo;
    // let { unionId = curUnionId, nickName: wxNickName, openId = curOpenId } = this.props.location.query;
    let isWechat = Utils.isWeiXin();
    // 微信环境，并且unionId，openId存在
    if (isWechat && unionId && openId) {
      let params = {
        unionId,
        openId,
        accessToken
      };
      // this.loginMod.queryBind(params).then(res => {
      //   if (`${res.resultCode}` === '0' && get(res, 'data.userId', null)) {
      //     // 如果此第三方账户已绑定完美账号，那么就不需要再弹框提示用户去绑定
      //     this.appMod.changeState('isBindingWechat', true);

      //     // 绑定了直接登录
      //     sessionStorage.setItem('fromPath', location.hash.split('#')[1].split('?')[0]);
      //     this.loginMod.login({ ...params, loginType: 7, applicationType: 1 }).then(res => {
      //       if (res.resultCode == 0) {
      //       } else {
      //         // 登录失败
      //         // sessionStorage.setItem('fromPath', location.hash.split('#')[1].split('?')[0]);
      //         window.app.routerRedirect('/shop/phoneLogin');
      //       }
      //     });
      //   } else {
      //     // 没绑定,缓存信息
      //     // 检查token，
      //     // 邀请开卡页面才需要检查token是否有效
      //     console.log(window.location.hash);
      //     let url = window.location.hash.split('#')[1].split('?')[0];
      //     if (url === '/share/openCard/inviteCode') {
      //       this.checkedToken();
      //     } else {
      //       // 假如进入的是商城，但是又是已经登录了的，这个时候又没有绑定微信，也需要弹窗提醒绑定
      //       this.checkedToken({
      //         isNotToLogin: true,
      //       });
      //     }
      //     this.appMod.changeState('isBindingWechat', false);
      //     // this.appMod.changeState('wxInfo', {
      //     //   openId,
      //     //   unionId,
      //     //   wxNickName,
      //     // });
      //   }
      //   // else {
      //   //   Toast.Info(res.resultMsg || '查询绑定信息失败');
      //   // }
      // });
    }
  };

  render() {
    return (
      <div className="app-wrap" style={{ height: '100%', overflow: 'scroll' }}>
        <div className="app" style={{ height: '100%' }}>
          <Router>
            <Switch>
              <Route path="/" component={Layout} />
            </Switch>
          </Router>
          <ToWeapp></ToWeapp>
          <PreviewMediaHost />
          <OverlayRoot />
        </div>
      </div>
    );
  }
}

export default AppView;



// WEBPACK FOOTER //
// ./src/widget/App/AppView.js